export const tourop = {
  tourops: [
    {
      kod: "ISLA",
      nazwa: "7islands",
      naszid: "TOOP00041"
    },
    {
      kod: "ALMA",
      nazwa: "Almatur",
      naszid: "TOOP00175"
    },
    {
      kod: "BVBE",
      nazwa: "Best Reisen",
      naszid: "TOOP00132"
    },
    {
      kod: "BVBX",
      nazwa: "Best Reisen Egzotyka",
      naszid: "TOOP00132"
    },
    {
      kod: "SYRG",
      nazwa: "BP Regent",
      naszid: "TOOP00157"
    },
    {
      kod: "WEZY",
      nazwa: "Coral Travel",
      naszid: "TOOP00034"
    },
    {
      kod: "DELT",
      nazwa: "Delta Travel",
      naszid: "TOOP00140"
    },
    {
      kod: "ECCO",
      nazwa: "Ecco Holiday",
      naszid: "TOOP00057"
    },
    {
      kod: "ECTR",
      nazwa: "Ecco Travel",
      naszid: "TOOP00043"
    },
    {
      kod: "ETI",
      nazwa: "ETI",
      naszid: "TOOP00179"
    },
    {
      kod: "VXEM",
      nazwa: "Europe Mountains",
      naszid: "TOOP00178"
    },
    {
      kod: "EXIM",
      nazwa: "Exim Tours",
      naszid: "TOOP00039"
    },
    {
      kod: "FNCB",
      nazwa: "Fun Club",
      naszid: "TOOP00127"
    },
    {
      kod: "GRCS",
      nazwa: "Grecos",
      naszid: "TOOP00130"
    },
    {
      kod: "ITAG",
      nazwa: "Itaka & Gala",
      naszid: "TOOP00063"
    },
    {
      kod: "VITG",
      nazwa: "Itaka & Gala",
      naszid: "TOOP00063"
    },
    {
      kod: "SYKM",
      nazwa: "Kompas",
      naszid: "TOOP00004"
    },
    {
      kod: "LTSL",
      nazwa: "Logos Travel",
      naszid: "TOOP00156"
    },
    {
      kod: "VXMT",
      nazwa: "Mouzenidis Travel",
      naszid: "TOOP00180"
    },
    {
      kod: "VNET",
      nazwa: "Net Holiday",
      naszid: "TOOP00167"
    },
    {
      kod: "ITAK",
      nazwa: "Nowa Itaka",
      naszid: "TOOP00063"
    },
    {
      kod: "VITX",
      nazwa: "Nowa Itaka",
      naszid: "TOOP00063"
    },
    {
      kod: "OASI",
      nazwa: "Oasis",
      naszid: "TOOP00069"
    },
    {
      kod: "OLIM",
      nazwa: "Olimp",
      naszid: "TOOP00092"
    },
    {
      kod: "VONH",
      nazwa: "Onholidays",
      naszid: "TOOP00177"
    },
    {
      kod: "VOSK",
      nazwa: "Oskar",
      naszid: "TOOP00141"
    },
    {
      kod: "VOTI",
      nazwa: "Otium Zima",
      naszid: "TOOP00068"
    },
    {
      kod: "DLPR",
      nazwa: "Prestige Holidays & Tours",
      naszid: "TOOP00150"
    },
    {
      kod: "BVPR",
      nazwa: "Prima Holiday",
      naszid: "TOOP00168"
    },
    {
      kod: "RNBW",
      nazwa: "Rainbow Tours",
      naszid: "TOOP00114"
    },
    {
      kod: "RETM",
      nazwa: "Retman",
      naszid: "TOOP00017"
    },
    {
      kod: "SNOW",
      nazwa: "Snowtrex",
      naszid: "TOOP00131"
    },
    {
      kod: "SFPL",
      nazwa: "Sun&Fun",
      naszid: "TOOP00135"
    },
    {
      kod: "TUIZ",
      nazwa: "TUI",
      naszid: "TOOP00099"
    },
    {
      kod: "BVWY",
      nazwa: "Wygoda",
      naszid: "TOOP00073"
    },
    {
      kod: "XYOB",
      nazwa: "Yobboo - Zing Travel",
      naszid: "TOOP00171"
    }
    // {
    //   kod: "SISL",
    //   nazwa: "7islands dep",
    //   naszid: "TOOP00041"
    // },
    // {
    //   kod: "ADR",
    //   nazwa: "Adriatyk",
    //   naszid: "TOOP00001"
    // },
    // {
    //   kod: "ALFA",
    //   nazwa: "Alfa Star",
    //   naszid: "TOOP00058"
    // },
    // {
    //   kod: "ALPE",
    //   nazwa: "Alpetour",
    //   naszid: "TOOP00100"
    // },
    // {
    //   kod: "ATLS",
    //   nazwa: "Atlas Tours",
    //   naszid: "TOOP00147"
    // },
    // {
    //   kod: "SYAT",
    //   nazwa: "Atur",
    //   naszid: "TOOP00049"
    // },
    // {
    //   kod: "BFRE",
    //   nazwa: "Bee Free",
    //   naszid: "TOOP00159"
    // },
    // {
    //   kod: "RBFR",
    //   nazwa: "Bee Free (Lato)",
    //   naszid: "TOOP00159"
    // },
    // {
    //   kod: "BVSO",
    //   nazwa: "Summerelse",
    //   naszid: "TOOP00163"
    // },
    // {
    //   kod: "DEST",
    //   nazwa: "Destino Mexico",
    //   naszid: "TOOP00062"
    // },
    // {
    //   kod: "DAMP",
    //   nazwa: "Easytour",
    //   naszid: "TOOP00123"
    // },
    // {
    //   kod: "EPTR",
    //   nazwa: "Europol Tour",
    //   naszid: "TOOP00040"
    // },
    // {
    //   kod: "BVGT",
    //   nazwa: "GTI",
    //   naszid: "TOOP00031"
    // },
    // {
    //   kod: "HERK",
    //   nazwa: "Herkules Express",
    //   naszid: "TOOP00065"
    // },
    // {
    //   kod: "MILE",
    //   nazwa: "III Millenium",
    //   naszid: "TOOP00014"
    // },
    // {
    //   kod: "JETT",
    //   nazwa: "JET Touristic",
    //   naszid: "TOOP00038"
    // },
    // {
    //   kod: "TRAD",
    //   nazwa: "Konsorcjum Polskich Biur Podróży",
    //   naszid: "TOOP00059"
    // },
    // {
    //   kod: "KONT",
    //   nazwa: "Kontynenty",
    //   naszid: "TOOP00129"
    // },
    // {
    //   kod: "LEKR",
    //   nazwa: "Lekier",
    //   naszid: "TOOP00115"
    // },
    // {
    //   kod: "LEMR",
    //   nazwa: "Lemur Travel",
    //   naszid: "TOOP00160"
    // },
    // {
    //   kod: "MADA",
    //   nazwa: "Madart",
    //   naszid: "TOOP00006"
    // },
    // {
    //   kod: "MATI",
    //   nazwa: "Matimpex Travel",
    //   naszid: "TOOP00002"
    // },
    // {
    //   kod: "MEGA",
    //   nazwa: "Mega Travel",
    //   naszid: "TOOP00081"
    // },
    // {
    //   kod: "NPL",
    //   nazwa: "Neckermann",
    //   naszid: "TOOP00138"
    // },
    // {
    //   kod: "HIT",
    //   nazwa: "Neckermann Hit",
    //   naszid: "TOOP00138"
    // },
    // {
    //   kod: "VOAS",
    //   nazwa: "Old Oasis",
    //   naszid: "TOOP00069"
    // },
    // {
    //   kod: "VOKS",
    //   nazwa: "OK Services",
    //   naszid: "TOOP00012"
    // },
    // {
    //   kod: "ORKA",
    //   nazwa: "Orka Travel",
    //   naszid: "TOOP00113"
    // },
    // {
    //   kod: "ORLA",
    //   nazwa: "Orlando Travel",
    //   naszid: "TOOP00036"
    // },
    // {
    //   kod: "OTIU",
    //   nazwa: "Otium",
    //   naszid: "TOOP00068"
    // },
    // {
    //   kod: "DELP",
    //   nazwa: "Prestige Holidays",
    //   naszid: "TOOP00150"
    // },
    // {
    //   kod: "REGE",
    //   nazwa: "Regent",
    //   naszid: "TOOP00157"
    // },
    // {
    //   kod: "RDLF",
    //   nazwa: "Rudolf Reisen",
    //   naszid: "TOOP00153"
    // },
    // {
    //   kod: "SNDB",
    //   nazwa: "Sindbad",
    //   naszid: "TOOP00003"
    // },
    // {
    //   kod: "SKRP",
    //   nazwa: "Skarpa",
    //   naszid: "TOOP00015"
    // },
    // {
    //   kod: "SKCL",
    //   nazwa: "Sky Club",
    //   naszid: "TOOP00139"
    // },
    // {
    //   kod: "SOPL",
    //   nazwa: "SOPOL",
    //   naszid: "TOOP00053"
    // },
    // {
    //   kod: "TENE",
    //   nazwa: "Tene Tour",
    //   naszid: "TOOP00011"
    // },
    // {
    //   kod: "TRTM",
    //   nazwa: "Terra Mare",
    //   naszid: "TOOP00033"
    // },
    // {
    //   kod: "TRIA",
    //   nazwa: "Triada",
    //   naszid: "TOOP00067"
    // },
    // {
    //   kod: "BVTR",
    //   nazwa: "Triada Lato",
    //   naszid: "TOOP00067"
    // },
    // {
    //   kod: "VIVA",
    //   nazwa: "Flash Tour",
    //   naszid: "TOOP00098"
    // },
    // {
    //   kod: "VOLA",
    //   nazwa: "Volare",
    //   naszid: "TOOP00119"
    // },
    // {
    //   kod: "WYGO",
    //   nazwa: "Wygoda",
    //   naszid: "TOOP00073"
    // },
    // {
    //   kod: "BVAC",
    //   nazwa: "Air Tours Club",
    //   naszid: "TOOP00176"
    // },
    // {
    //   kod: "YOUN",
    //   nazwa: "Young Travel",
    //   naszid: "TOOP00023"
    // },
    // {
    //   kod: "AQUA",
    //   nazwa: "Aquamaris",
    //   naszid: "TOOP00162"
    // },
    // {
    //   kod: "FTON",
    //   nazwa: "U Właściciela",
    //   naszid: "TOOP00045"
    // },
    // {
    //   kod: "BVCC",
    //   nazwa: "Comfort Club",
    //   naszid: "TOOP00164"
    // },
    // {
    //   kod: "SAGL",
    //   nazwa: "Globtrans",
    //   naszid: "TOOP00042"
    // },
    // {
    //   kod: "TUI",
    //   nazwa: "TUI Poland Standard",
    //   naszid: "TOOP00099"
    // },
    // {
    //   kod: "TUIP",
    //   nazwa: "TUI Poland (P)",
    //   naszid: "TOOP00099"
    // },
    // {
    //   kod: "TUIF",
    //   nazwa: "TUI Poland (Fresh)",
    //   naszid: "TOOP00099"
    // },
    // {
    //   kod: "BVCN",
    //   nazwa: "Citron Travel",
    //   naszid: "TOOP00169"
    // },
    // {
    //   kod: "INDX",
    //   nazwa: "INDEX",
    //   naszid: "TOOP00170"
    // },
    // {
    //   kod: "ATLP",
    //   nazwa: "Atlas Tours Rejsy",
    //   naszid: "TOOP00147"
    // },
    // {
    //   kod: "VRGT",
    //   nazwa: "Regent",
    //   naszid: "TOOP00157"
    // },
    // {
    //   kod: "OKTU",
    //   nazwa: "OK. Tours",
    //   naszid: "TOOP00172"
    // },
    // {
    //   kod: "VGAM",
    //   nazwa: "GAMA",
    //   naszid: "TOOP00173"
    // },
    // {
    //   kod: "NDAM",
    //   nazwa: "Nev-Dama",
    //   naszid: "TOOP00174"
    // },
    // {
    //   kod: "XTOP",
    //   nazwa: "TOP Touristik",
    //   naszid: "TOOP00181"
    // }
  ]
};
